import { Button } from "@shadcn/components/ui/button";
import { Pencil } from "lucide-react";
import { VehicleResult } from "./api";

type VehicleSearchResultsProps = {
  disabled?: boolean;
  selectedVehicle: VehicleResult | null;
  searchQuery: string;
  onSearchAgain: () => void;
  onEdit: () => void;
};

export const VehicleSearchResults = ({
  disabled,
  selectedVehicle,
  searchQuery,
  onSearchAgain,
  onEdit,
}: VehicleSearchResultsProps) => {
  return (
    <>
      <div className="flex items-center justify-end mb-4">
        <Button type="button" variant="outline" size="sm" onClick={onSearchAgain} disabled={disabled}>
          Search again
        </Button>
      </div>
      {selectedVehicle && (
        <div className="rounded-md border bg-muted/50 p-4 space-y-2">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Registration Plate</p>
              <p className="text-sm">{searchQuery || "—"}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Make</p>
              <p className="text-sm">{selectedVehicle.make || "—"}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Model</p>
              <p className="text-sm">{selectedVehicle.model || "—"}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Colour</p>
              <p className="text-sm">{selectedVehicle.colour || "—"}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Year</p>
              <p className="text-sm">{selectedVehicle.yearOfManufacture || "—"}</p>
            </div>
          </div>
          <div className="flex justify-end mt-3">
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={onEdit}
              disabled={disabled}
            >
              <Pencil className="mr-2 h-4 w-4" />
              Edit
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

